'use client'


import { useState, useEffect } from 'react'
import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
import { ShoppingCartIcon } from "@heroicons/react/16/solid";
import { Link } from "react-router"
import axios from 'axios';
import Navbar from './landing/navbar'
import Carousel from './carousel';
import CarouselSlide from './carouselSlide';
import Footer from './footer';
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
import ProductList from './productList';

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ')
// }

// const navigation = [
//   { name: 'Home', href: '#', current: true },
//   { name: 'Product', href: '#sector1', current: false },
//   { name: 'Feedback', href: '#sector2', current: false },
//   { name: 'Calendar', href: '#sector3', current: false },
// ]

// const posts = [
//   {
//     id: 1,
//     title: 'Boost your conversion rate',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     imgUrl:'landing4.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: { title: 'Marketing', href: '#' },
//     author: {
//       name: 'Michael Foster',
//       role: 'Co-Founder / CTO',
//       href: '#',
//       imageUrl:'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
//     },
//   },
//   {
//     id: 2,
//     title: 'How to use search engine optimization to drive sales',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     imgUrl:'landing5.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: { title: 'Sales', href: '#' },
//     author: {
//       name: 'Lindsay Walton',
//       role: 'CFront-end Developer',
//       href: '#',
//       imageUrl:'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
//     },
//   },
//   {
//     id: 3,
//     title: 'Improve your customer experience',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'landing6.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: { title: 'Business', href: '#' },
//     author: {
//       name: 'Tom Cook',
//       role: 'Director of Product',
//       href: '#',
//       imageUrl:
//         'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
//     },
//   },
//   // More posts...
// ]

const features = [
  {
    name: 'ใหม่ สด ทุกวัน.',
    description:
      'ด้วยการผลิตที่ได้มาตรฐาน สะอาด ใส่ใจในทุกขั้นตอนการผลิต ทำให้รสชาติอร่อย ไม่ซ้ำใคร ',
    icon: CloudArrowUpIcon,
  },
  {
    name: 'ใช้วัติถุดิบที่ปลอดภัย',
    description: 'เราใส่ใจในความปลอดภัยของสินค้า จึงเลือกใช้วัตุดิบที่มีคุณภาพ ได้มาตรฐาน ',
    icon: LockClosedIcon,
  },
  {
    name: 'มีการตวจสอบสม่ำเสมอ',
    description: 'เรามีการตรวจสอบคุณภาพสินค้า ตลอดเวลา เพื่อให้ลูกค้ามั่นใจว่าจะได้รับสินค้าที่มีคุณภาพ',
    icon: ServerIcon,
  },
]

// const links = [
//   { name: 'Open roles', href: '#' },
//   { name: 'Internship program', href: '#' },
//   { name: 'Our values', href: '#' },
//   { name: 'Meet our leadership', href: '#' },
// ]
// const stats = [
//   { name: 'Offices worldwide', value: '12' },
//   { name: 'Full-time colleagues', value: '300+' },
//   { name: 'Hours per week', value: '40' },
//   { name: 'Paid time off', value: 'Unlimited' },
// ]

// const products = [
//   {
//     id: 1,
//     title: 'Cake browny',
//     price: '129฿',
//     instock: '200',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     imgUrl:'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
//   {
//     id: 2,
//     title: 'chiffon-cake',
//     price: '89฿',
//     instock: '159',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     imgUrl:'https://cookingwithdog.com/wp-content/uploads/2021/03/chiffon-cake-00-1615696212.9265.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 3,
//     title: 'Yellow Bowl Chiffon',
//     price: '79฿',
//     instock: '179',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://assets.epicurious.com/photos/627aaf5f080d9862e3bda7d6/1:1/w_2560%2Cc_limit/PandanChiffon_RECIPE_050522_33403.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 4,
//     title: 'Cake browny',
//     price: '109฿',
//     instock: '159',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     imgUrl:'https://www.allrecipes.com/thmb/JaPmyuRaOPDlGkkk0FwLKu2eoSo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/7892-chiffon-cake-ddmfs-11960-4x3-31cd0f36773640b193318e76a978cc0a.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
//   {
//     id: 5,
//     title: 'Chiffon coconut',
//     price: '119฿',
//     instock: '159',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     imgUrl:'https://zhangcatherine.com/wp-content/uploads/2022/03/12001200.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 6,
//     title: 'Citrus-Chiffon',
//     price: '129฿',
//     instock: '179',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://bakefromscratch.com/wp-content/uploads/2022/05/Citrus-Chiffon-312JBweb.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 7,
//     title: 'blueberry-chiffon-cake',
//     price: '159฿',
//     instock: '200',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     imgUrl:'https://teakandthyme.com/wp-content/uploads/2024/10/blueberry-chiffon-cake-DSC_2632-1x1-1200.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
//   {
//     id: 8,
//     title: 'browny Choce',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     imgUrl:'https://www.tasteofhome.com/wp-content/uploads/2018/01/exps164_MC163887B03_10_24b.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 9,
//     title: 'Box4-Chiffon',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://down-id.img.susercontent.com/file/709385c8df2fb4c8ee3050dc4ba84c52',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 10,
//     title: 'BirthDay-chiffon-cake',
//     price: '159฿',
//     instock: '200',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     imgUrl:'https://down-id.img.susercontent.com/file/dcb34b2ef6fd04941a85432da9dd6d11',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
//   {
//     id: 11,
//     title: 'Coffee Mocha',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     imgUrl:'https://images.tokopedia.net/img/cache/500-square/VqbcmM/2021/3/18/ef0914b3-1016-474f-8829-ca599832d4d5.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 12,
//     title: 'Matcha-Chiffon',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://www.siftandsimmer.com/wp-content/uploads/2022/10/matcha-chiffon-cake-featured.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//   id: 13,
//     title: 'Chocolate Icing',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     imgUrl:'https://www.pholfoodmafia.com/wp-content/uploads/2018/05/1000x650ChocolateChiffonCakewithChocolateIcing-590x418.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 14,
//     title: 'fruit-Chiffon',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://www.deliciousmagazine.co.uk/wp-content/uploads/2023/04/S2023D103_SEO_CHIFFON_3__-768x960.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 15,
//     title: 'Coconut Chiff',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://www.marthastewart.com/thmb/5Gd1v4aTAfMoBsG-OFGjer7SbmI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/coconut-chiffon-cake-with-chocolate-frosting-102881873_horiz-6375bc36fd9c4ea587b1bfab1ed2a739.jpgitokjIv4LmSM',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 16,
//     title: 'Lemon Meringue',
//     price: '179฿',
//     instock: '200',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     imgUrl:'https://domesticdreamboat.com/wp-content/uploads/2022/04/Lemon-Meringue-Chiffon-Cake-Cut-cropped.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   // More posts...
// ]

// const promote = [
//   {
//     id: 1,
//     name: 'Cake browny',
//     price: '129฿',
//     instock: '200',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     img:'https://cdn.pixabay.com/photo/2020/04/30/06/34/food-5111643_640.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
//   {
//     id: 2,
//     name: 'chiffon-cake',
//     price: '89฿',
//     instock: '159',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     img:'https://cdn.pixabay.com/photo/2017/11/14/08/55/homemade-2947832_640.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 3,
//     name: 'Yellow Bowl Chiffon',
//     price: '79฿',
//     instock: '179',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     img:'https://cdn.pixabay.com/photo/2018/01/04/11/40/cake-3060458_640.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 4,
//     name: 'Cake browny',
//     price: '109฿',
//     instock: '159',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     img:'https://cdn.pixabay.com/photo/2020/02/29/15/20/cake-4890393_640.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
//   {
//     id: 5,
//     name: 'Chiffon coconut',
//     price: '119฿',
//     instock: '159',
//     href: '#',
//     description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
//     img:'https://cdn.pixabay.com/photo/2018/09/11/11/47/cake-3669245_640.jpg',
//     date: 'Mar 10, 2020',
//     datetime: '2020-03-10',
//     category: 'Chiffon',
//   },
//   {
//     id: 6,
//     name: 'Citrus-Chiffon',
//     price: '129฿',
//     instock: '179',
//     href: '#',
//     description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
//     img:'https://cdn.pixabay.com/photo/2020/03/10/03/49/red-velvet-cake-4917734_640.jpg',
//     date: 'Mar 12, 2020',
//     datetime: '2020-03-12',
//     category: 'Bakery',
//   },
//   {
//     id: 7,
//     name: 'blueberry-chiffon-cake',
//     price: '159฿',
//     instock: '200',
//     href: '#',
//     description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
//     img:'https://cdn.pixabay.com/photo/2018/07/01/19/50/muffin-3510308_640.jpg',
//     date: 'Mar 16, 2020',
//     datetime: '2020-03-16',
//     category: 'Cakes',
//   },
// ];

const apiurl = `${process.env.REACT_APP_API}/products.php`

export default function Index() {
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [pdFilter, setPdFilter] = useState('All');
  const [promot, setPromote] = useState(null);
  const carts = useCarts();
  const dispatch = useCartsDispatch();

  // const cart = localStorage.getItem("cart");

  // if(cart) {

  // }


  useEffect(() => {
    const fetchPromote = async () => {
      try {
        const result = await axios.get(`${apiurl}?mode=getpromote`);
        
        // console.log(result);
        // console.log(result.data);
        // if(result.data.length>0) {
        if(result.data && result.data[0].length>0) {  
          // const data = await response.json();
          // console.log(result.data[0]);
          setPromote(result.data[0]);
          return result.data[0];
        } //else {
         // setPromote(promote);
       // }
      }
      catch(err) {
          console.log(err);
        }
      }
  
      fetchPromote();
    
  },[]); 
  
  const setCart = async (pd) => {
    // console.log(pd)

    const cartitem = carts.filter((cart) => cart.pdid === pd.id);
    if (cartitem && cartitem.length > 0) {
      dispatch({
        type: 'changed',
        // id: pd.id,
        pdid: pd.id,
        name: pd.name,
        // discount: 0,
        price: pd.price,
        quantity: 1,
        imageSrc: pd.img,

      });
      
    } else {
      dispatch({
        type: 'added',
        id: pd.id,
        pdid: pd.id,
        name: pd.name,
        // discount: 0,
        price: pd.price,
        quantity: 1,
        imageSrc: pd.img,

      });
    };
  };
  
  // const prods = pdFilter==="All"? products : products.filter(pd => pd.category === pdFilter)

  return (
    <div className="w-full min-w-96 bg-gradient-to-br from-slate-900 from-10% via-slate-700 via-45% to-slate-800 to-85%" >
      
        <div className="flex justify-center h-16">
              <Navbar />
        </div>
        <div className="flex items-center justify-center rounded-xl max-w-5xl mt-4 xl:mt-8 mx-auto bg-cover bg-center" style={{backgroundImage: 'url(/noodles.jpg)'}}>
          {promot && (
            <div className="w-full max-w-7xl mx-auto p-4 text-slate-400 rounded-xl">
                    <CarouselSlide slides={promot} autoSlide={true} autoSlideInterval={5000} />
            </div>
          )}
        </div>
        <div className="mx-auto justify-center max-w-5xl grid grid-cols-1 sm:grid-cols-2 px-4 py-0 sm:py-2">
            <div className="text-center pt-20 md:pt-6">
              <h1 className="itim-regular text-balance text-4xl font-semibold tracking-tight text-gray-300 md:text-5xl">
                คนสู้ชีวิต แต่โดนชีวิตสู้กลับ
              </h1>
              <p className="itim-regular px-4 mt-8 text-pretty text-lg font-medium text-gray-400 sm:text-xl/8">
                จึงต้องประกาศสงครามชีวิต!!!<br /> โชคชะตา ฟ้าลิขิต <br /> จะพิชิตความมานะตนก็ให้มันรู้ไป... <br /> <br />
                ...ขอเชิญชวนทุกท่านมาลองชิมบะหมี่3เอ็น สุดยอดของความอร่อย ที่คัดสรรมาเป็นอย่างดี จากความตั้งใจปรุงแต่ง เพื่อให้ได้รสชาติที่ถูกปาก ซี๊ดซ๊าด ถูกใจ.
              </p>
              <div className="flex items-center justify-center p-6 py-4 gap-x-8">
                {/* <Link
                  to="/login"
                  className="rounded-md bg-indigo-600 px-4 py-3  text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 "
                >
                  ติดต่อเรา
                </Link> */}

                {/* <a href="#sector1" className="block text-sm/6 font-semibold text-gray-600 hover:text-blue-400 p-2">
                  รายการสินค้า <span aria-hidden="true">→</span>
                </a> */}

              </div>
            </div>
            <div className="flex justify-center">
              <img
                alt="คนสู้ชีวิต"
                src="https://cdn.pixabay.com/photo/2023/06/23/12/42/tea-8083484_640.jpg"
                width={200}
                height={200}
                className="justify-center w-80  max-w-none rounded-3xl  shadow-xl ring-1 ring-gray-400/10 md:w-96 mt-4 md:mt-4 "
              />
            </div>
          </div>

          {/* <div className="mx-auto py-4 md:py-2">
            <Carousel />
          </div> */}

        <div className="mx-auto justify-center max-w-5xl grid grid-cols-1 gap-6 sm:grid-cols-2 px-4  py-0 sm:py-8">
          <div className="flex justify-center">
                <img
                  alt="Product screenshot"
                  src="https://cdn.pixabay.com/photo/2017/05/30/11/28/chef-2356648_640.jpg"
                  width={200}
                  height={200}
                  className="justify-center w-80  max-w-none rounded-3xl  shadow-xl ring-1 ring-gray-400/10 md:w-96 mt-16 md:mt-2 "
                />
              </div>            
            <div className="justify-center  md:text-start pt-2">
              <h2 className="itim-regular text-base/7 font-semibold text-indigo-600">ใหม่ สด ทุกวัน</h2>
                <p className="itim-regular mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-300 sm:text-5xl">
                  ผลิตวันต่อวัน 
                </p>
                <p className="itim-regular mt-6 text-lg/8 text-gray-300">
                  การผลิตที่ได้มาตรฐาน  สะอาด ปลอดภัย ผลิตวันต่อวัน 
                </p>
                <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-300 lg:max-w-none">
                  {features.map((feature) => (
                    <div key={feature.name} className="relative pl-9">
                      <dt className="inline font-semibold text-gray-300">
                        <feature.icon aria-hidden="true" className="absolute left-1 top-1 size-5 text-indigo-600" />
                        {feature.name}
                      </dt>{' '}
                      <dd className="inline">{feature.description}</dd>
                    </div>
                  ))}
                </dl>
            </div>
            
          </div>

      <div id="sector1" className="mt-4">
        <ProductList   />
      {/* <div className="text-gray-300 mx-auto  px-6 py-6 max-w-7xl lg:px-4">
        <h2 className="text-2xl font-bold tracking-tight">Products</h2> 
        <span>
           <button onClick={() => setPdFilter('All')} className="hover:text-slate-500"> All </button> <span> / </span>
           <button onClick={() => setPdFilter('Bakery')} className="hover:text-slate-500"> Bakery </button> <span> / </span> 
           <button onClick={() => setPdFilter('Cakes')} className="hover:text-slate-500"> Cake </button> <span> / </span> 
           <button onClick={() => setPdFilter('Chiffon')} className="hover:text-slate-500"> Chiffon </button>
        </span>
        <div className="mt-6 grid gap-x-6 gap-y-10 grid-cols-2 md:grid-cols-4 xl:gap-x-6">
          {prods.map((product) => (
            <div key={product.id} className="group relative rounded-md bg-gray-300">
              <img
                alt={product.imgUrl}
                src={product.imgUrl}
                className="aspect-square w-full rounded-md bg-gray-200 object-cover group-hover:opacity-75 lg:aspect-auto lg:h-80"
              />
              <div className="mt-4 p-1 flex justify-between">
                <div>
                  <h3 className="text-sm text-gray-900">
                    <a href={product.href}>
                      <span aria-hidden="true" className="" />
                      {product.title}
                    </a>
                  </h3>
                  <p className="mt-1 text-sm text-gray-900 inline-block">{product.category}</p>
                  <ShoppingCartIcon 
                    className="h-6 w-6 ml-4 text-teal-500 inline-block hover:text-teal-700 hover:cursor-pointer"
                    onClick={() => setCart(product)}
                  />
                </div>
                <p className="flex items-center p-1  text-sm font-medium text-gray-300 bg-slate-500 rounded-full">{product.price}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
    </div>

    {/* <div className="text-gray-300 mx-auto  px-6 py-6  md:px-6 md:py-6 max-w-7xl lg:px-4">
      <h2 className="text-2xl font-bold tracking-tight">Customer also purchase</h2>
      <div id="sector2" className="overflow-y-auto h-[600px] mx-auto grid grid-cols-2 gap-x-2 gap-y-6 border-t border-gray-200 p-4 mt-4  md:grid-cols-4 lg:grid-cols-5 ">
              {prods.map((prod) => (
                <div key={prod.id} className="flex max-w-xl flex-col">
                    <div className="flex p-0 hover:border-orange-500 hover:border-2 hover:rounded-md">
                      <img alt="" className="w-full aspect-square rounded-md bg-gray-50"
                          src={prod.imgUrl} 
                      />
                    </div>
                  <div className="flex w-full rounded-lg items-center justify-between  text-xs pt-2">
                    <p
                      // href={prod.category}
                      className="relative px-3 py-1.5 font-medium text-slate-400"
                    >
                      {prod.title}
                    </p>
                    <p className="relative  rounded-full bg-gray-300 px-3 py-1.5 font-medium text-gray-700 hover:bg-gray-100">
                        {prod.price}
                    </p>
                  </div>
                </div>
              ))}
      </div>
    </div>  */}
        {/* <div className=" py-16 sm:py-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:mx-0">
              <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-400 sm:text-5xl">From the blog</h2>
              <p className="mt-2 text-lg/8 text-gray-400">Learn how to grow your business with our expert advice.</p>
            </div>
            <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              {posts.map((post) => (
                <article key={post.id} className="flex max-w-xl flex-col items-start justify-between">
                  <div className="flex items-center gap-x-4 text-xs">
                    <time dateTime={post.datetime} className="text-gray-400">
                      {post.date}
                    </time>
                    <Link
                      href={post.category.href}
                      className="relative  rounded-full bg-gray-500 px-3 py-1.5 font-medium text-gray-300 hover:bg-gray-400"
                    >
                      {post.category.title}
                    </Link>
                  </div>
                  <div className="group relative">
                    <h3 className="mt-3 text-lg/6 font-semibold text-gray-400 group-hover:text-gray-300">
                      <a href={post.href}>
                        <span className="absolute inset-0" />
                        {post.title}
                      </a>
                    </h3>
                    <p className="mt-5 line-clamp-3 text-sm/6 text-gray-400">{post.description}</p>
                  </div>
                  <div className="relative mt-8 flex items-center gap-x-4">
                    <img alt="" src={post.author.imageUrl} className="size-10 rounded-full bg-gray-50" />
                    <div className="text-sm/6">
                      <p className="font-semibold text-gray-400">
                        <Link href={post.author.href}>
                          <span className="absolute inset-0" />
                          {post.author.name}
                        </Link>
                      </p>
                      <p className="text-gray-400">{post.author.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>

        <div className=" py-14 sm:py-14">
          <div className="mx-auto max-w-7xl px-6 md:px-8">
            <div className="mx-auto max-w-2xl md:mx-0">
              <h2 className="text-pretty text-4xl font-semibold tracking-tight text-gray-300 sm:text-5xl">From the Social</h2>
              <p className="mt-2 text-lg/8 text-gray-400">Learn how to grow your business with our expert advice.</p>
            </div>
            <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 md:mx-0 md:max-w-none md:grid-cols-3">
              {posts.map((post) => (
                <article key={post.id} className="flex max-w-xl flex-col items-start justify-between">
                    <div className="flex p-1 pb-2">
                      <img alt="" className="size-auto rounded-xl bg-gray-500"
                          src={post.imgUrl} 
                      />
                    </div>
                  <div className="flex items-center gap-x-4 text-xs">
                    <time dateTime={post.datetime} className="text-gray-300">
                      {post.date}
                    </time>
                    <Link
                      href={post.category.href}
                      className="relative  rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-400 hover:bg-gray-300"
                    >
                      {post.category.title}
                    </Link>
                  </div>
                  <div className="group relative">
                    <h3 className="mt-3 text-lg/6 font-semibold text-gray-400 group-hover:text-gray-200">
                      <Link href={post.href}>
                        <span className="absolute inset-0" />
                        {post.title}
                      </Link>
                    </h3>
                    <p className="mt-5 line-clamp-3 text-sm/6 text-gray-400">{post.description}</p>
                  </div>
                  <div className="relative mt-8 flex items-center gap-x-4">
                    <img alt="" src={post.author.imageUrl} className="size-10 rounded-full bg-gray-50" />
                    <div className="text-sm/6">
                      <p className="font-semibold text-gray-400">
                        <Link href={post.author.href}>
                          <span className="absolute inset-0" />
                          {post.author.name}
                        </Link>
                      </p>
                      <p className="text-gray-400">{post.author.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>


      <div className="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32">
      <img
        alt=""
        src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-y=.8&w=2830&h=1500&q=80&blend=111827&sat=-100&exp=15&blend-mode=multiply"
        className="absolute inset-0  size-full object-cover object-right md:object-center"
      />
      <div
        aria-hidden="true"
        className="hidden sm:absolute sm:-top-10 sm:right-1/2  sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
      >
        <div
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
          className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
        />
      </div>
      <div
        aria-hidden="true"
        className="absolute -top-52 left-1/2  -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
      >
        <div
          style={{
            clipPath:
              'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
          }}
          className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
        />
      </div>
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-5xl font-semibold tracking-tight text-white sm:text-7xl">Work with us</h2>
          <p className="mt-8 text-pretty text-lg font-medium text-gray-300 sm:text-xl/8">
            Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet
            fugiat veniam occaecat fugiat.
          </p>
        </div>
        <div className="mx-auto mt-10 max-w-2xl lg:mx-0 lg:max-w-none">
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 text-base/7 font-semibold text-white sm:grid-cols-2 md:flex lg:gap-x-10">
            {links.map((link) => (
              <Link key={link.name} href={link.href}>
                {link.name} <span aria-hidden="true">&rarr;</span>
              </Link>
            ))}
          </div>
          <dl className="mt-16 grid grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.name} className="flex flex-col-reverse gap-1">
                <dt className="text-base/7 text-gray-300">{stat.name}</dt>
                <dd className="text-4xl font-semibold tracking-tight text-white">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>

    <div id="sector3" className="relative isolate overflow-hidden bg-gray-900 py-16 sm:py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
          <div className="max-w-xl lg:max-w-lg">
            <h2 className="text-4xl font-semibold tracking-tight text-white">Subscribe to our newsletter</h2>
            <p className="mt-4 text-lg text-gray-300">
              Nostrud amet eu ullamco nisi aute in ad minim nostrud adipisicing velit quis. Duis tempor incididunt
              dolore.
            </p>
            <div className="mt-6 flex max-w-md gap-x-4">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                required
                placeholder="Enter your email"
                autoComplete="email"
                className="min-w-0 flex-auto rounded-md bg-white/5 px-3.5 py-2 text-base text-white outline outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:text-sm/6"
              />
              <button
                type="submit"
                className="flex-none rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                Subscribe
              </button>
            </div>
          </div>
          <dl className="grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:pt-2">
            <div className="flex flex-col items-start">
              <div className="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                <CalendarDaysIcon aria-hidden="true" className="size-6 text-white" />
              </div>
              <dt className="mt-4 text-base font-semibold text-white">Weekly articles</dt>
              <dd className="mt-2 text-base/7 text-gray-400">
                Non laboris consequat cupidatat laborum magna. Eiusmod non irure cupidatat duis commodo amet.
              </dd>
            </div>
            <div className="flex flex-col items-start">
              <div className="rounded-md bg-white/5 p-2 ring-1 ring-white/10">
                <HandRaisedIcon aria-hidden="true" className="size-6 text-white" />
              </div>
              <dt className="mt-4 text-base font-semibold text-white">No spam</dt>
              <dd className="mt-2 text-base/7 text-gray-400">
                Officia excepteur ullamco ut sint duis proident non adipisicing. Voluptate incididunt anim.
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>


    <div className="bg-slate-400 bg-g py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-lg/8 font-semibold text-gray-900">
          Trusted by the world’s most innovative teams
        </h2>
        <div className="mx-auto mt-10 grid max-w-lg grid-cols-4 items-center gap-x-8 gap-y-10 sm:max-w-xl sm:grid-cols-6 sm:gap-x-10 lg:mx-0 lg:max-w-none lg:grid-cols-5">
          <img
            alt="Transistor"
            src="https://tailwindui.com/plus/img/logos/158x48/transistor-logo-gray-900.svg"
            width={158}
            height={48}
            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
          />
          <img
            alt="Reform"
            src="https://tailwindui.com/plus/img/logos/158x48/reform-logo-gray-900.svg"
            width={158}
            height={48}
            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
          />
          <img
            alt="Tuple"
            src="https://tailwindui.com/plus/img/logos/158x48/tuple-logo-gray-900.svg"
            width={158}
            height={48}
            className="col-span-2 max-h-12 w-full object-contain lg:col-span-1"
          />
          <img
            alt="SavvyCal"
            src="https://tailwindui.com/plus/img/logos/158x48/savvycal-logo-gray-900.svg"
            width={158}
            height={48}
            className="col-span-2 max-h-12 w-full object-contain sm:col-start-2 lg:col-span-1"
          />
          <img
            alt="Statamic"
            src="https://tailwindui.com/plus/img/logos/158x48/statamic-logo-gray-900.svg"
            width={158}
            height={48}
            className="col-span-2 col-start-2 max-h-12 w-full object-contain sm:col-start-auto lg:col-span-1"
          />
        </div>
      </div>
    </div> */}
    
    <div className="mx-auto max-w-7xl justify-center">
      <Footer />
    </div>
  </div>

  )
}
